"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = isObject;
exports.convertToPlainJsObject = convertToPlainJsObject;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * As series of mundane Javascript functions that should be in Javascript already
 */

/**
 * A check to see if the value is a valid object
 * @param val
 */
function isObject(val) {
  if (val === null) {
    return false;
  }

  return typeof val === 'function' || (0, _typeof2.default)(val) === 'object';
}
/**
 * Converts an object into a plain Javascript Object and removes any undefined and null fields
 * @param object
 */


function convertToPlainJsObject(object) {
  var obj = _objectSpread({}, object);

  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }

  return obj;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL2luZGV4LnRzIl0sIm5hbWVzIjpbImlzT2JqZWN0IiwidmFsIiwiY29udmVydFRvUGxhaW5Kc09iamVjdCIsIm9iamVjdCIsIm9iaiIsInByb3BOYW1lIiwidW5kZWZpbmVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTtBQUNBO0FBQ0E7O0FBR0E7QUFDQTtBQUNBO0FBQ0E7QUFDTyxTQUFTQSxRQUFULENBQWtCQyxHQUFsQixFQUFxQztBQUMxQyxNQUFJQSxHQUFHLEtBQUssSUFBWixFQUFrQjtBQUNoQixXQUFPLEtBQVA7QUFDRDs7QUFDRCxTQUFTLE9BQU9BLEdBQVAsS0FBZSxVQUFoQixJQUFnQyxzQkFBT0EsR0FBUCxNQUFlLFFBQXZEO0FBQ0Q7QUFFRDtBQUNBO0FBQ0E7QUFDQTs7O0FBQ08sU0FBU0Msc0JBQVQsQ0FBZ0NDLE1BQWhDLEVBQWtGO0FBQ3ZGLE1BQU1DLEdBQUcscUJBQU9ELE1BQVAsQ0FBVDs7QUFDQSxPQUFLLElBQU1FLFFBQVgsSUFBdUJELEdBQXZCLEVBQTRCO0FBQzFCLFFBQUlBLEdBQUcsQ0FBQ0MsUUFBRCxDQUFILEtBQWtCLElBQWxCLElBQTBCRCxHQUFHLENBQUNDLFFBQUQsQ0FBSCxLQUFrQkMsU0FBaEQsRUFBMkQ7QUFDekQsYUFBT0YsR0FBRyxDQUFDQyxRQUFELENBQVY7QUFDRDtBQUNGOztBQUNELFNBQU9ELEdBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQXMgc2VyaWVzIG9mIG11bmRhbmUgSmF2YXNjcmlwdCBmdW5jdGlvbnMgdGhhdCBzaG91bGQgYmUgaW4gSmF2YXNjcmlwdCBhbHJlYWR5XG4gKi9cblxuXG4vKipcbiAqIEEgY2hlY2sgdG8gc2VlIGlmIHRoZSB2YWx1ZSBpcyBhIHZhbGlkIG9iamVjdFxuICogQHBhcmFtIHZhbFxuICovXG5leHBvcnQgZnVuY3Rpb24gaXNPYmplY3QodmFsOiBhbnkpOiBib29sZWFuIHtcbiAgaWYgKHZhbCA9PT0gbnVsbCkge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuICByZXR1cm4gKCh0eXBlb2YgdmFsID09PSAnZnVuY3Rpb24nKSB8fCAodHlwZW9mIHZhbCA9PT0gJ29iamVjdCcpKTtcbn1cblxuLyoqXG4gKiBDb252ZXJ0cyBhbiBvYmplY3QgaW50byBhIHBsYWluIEphdmFzY3JpcHQgT2JqZWN0IGFuZCByZW1vdmVzIGFueSB1bmRlZmluZWQgYW5kIG51bGwgZmllbGRzXG4gKiBAcGFyYW0gb2JqZWN0XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjb252ZXJ0VG9QbGFpbkpzT2JqZWN0KG9iamVjdDogUmVjb3JkPHN0cmluZywgYW55Pik6IFJlY29yZDxzdHJpbmcsIGFueT4ge1xuICBjb25zdCBvYmogPSB7Li4ub2JqZWN0fVxuICBmb3IgKGNvbnN0IHByb3BOYW1lIGluIG9iaikge1xuICAgIGlmIChvYmpbcHJvcE5hbWVdID09PSBudWxsIHx8IG9ialtwcm9wTmFtZV0gPT09IHVuZGVmaW5lZCkge1xuICAgICAgZGVsZXRlIG9ialtwcm9wTmFtZV07XG4gICAgfVxuICB9XG4gIHJldHVybiBvYmo7XG59XG4iXX0=